module.exports = __webpack_public_path__ + "static/media/loading.6520936e.svg";